import { Sheet, SheetContent, SheetHeader } from '@/components/ui/sheet';
import type { PolicyWithChange } from '../utils/policyProposalUtils';
import { PolicyHeader } from './policy-display';
import { PolicyDisplayForm } from './policy-display-form';

interface PolicyDetailSheetProps {
  policy: PolicyWithChange | null;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  isInEditMode?: boolean;
  onEditClick?: () => void;
}

export function PolicyDetailSheet({
  policy,
  isOpen,
  onOpenChange,
  isInEditMode = false,
  onEditClick,
}: PolicyDetailSheetProps) {
  if (!policy) return null;

  const handleBackdropClick = () => {
    onOpenChange(false);
  };

  const handleEditButtonClick = () => {
    if (onEditClick) {
      onEditClick();
    }
  };

  return (
    <>
      <Sheet open={isOpen} onOpenChange={onOpenChange} modal={false}>
        {/* Custom backdrop overlay */}
        {isOpen && (
          <div
            className="fixed inset-0 z-[60] bg-black/80 top-0 left-0 right-0 bottom-0 !m-0 p-0"
            onClick={handleBackdropClick}
          />
        )}

        <SheetContent
          side="right"
          className="overflow-y-auto !w-[800px] !max-w-[800px] bg-muted !z-[61]"
        >
          <SheetHeader className="gap-4 border-b sticky -top-6 bg-background left-0 right-0 pb-4 -m-6 p-6 z-[5]">
            <PolicyHeader
              policy={policy}
              showEditButton={isInEditMode}
              onEditClick={handleEditButtonClick}
              isInEditMode={isInEditMode}
              className="border-b-0 pb-0"
            />
          </SheetHeader>

          <div className="flex flex-col gap-6 py-6 mt-6">
            <PolicyDisplayForm policy={policy} />
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
}
